import { useState } from 'react';
import { login } from '../api';

export default function Login({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      await login(email, password);
      onLogin();
    } catch (e: any) {
      setErr(
        e.message === 'invalid_credentials'
          ? 'E-Mail oder Passwort falsch.'
          : e.message.includes('fetch') ? 'Backend nicht erreichbar.' : e.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-overlay">
      <form className="login-box" onSubmit={onSubmit}>
        <div className="login-logo">P</div>
        <h1 style={{ margin: '0 0 6px' }}>Praxis-Dashboard</h1>
        <p style={{ color: '#5F6B68', margin: '0 0 24px', fontSize: 14 }}>
          Melde dich mit den Praxis-Zugangsdaten an, die du von Bertsy bekommen hast.
        </p>
        <div className="field">
          <label>Praxis-E-Mail</label>
          <input type="email" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="field">
          <label>Passwort</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          {err && <div className="error">{err}</div>}
        </div>
        <button className="btn btn-primary" style={{ width: '100%' }} type="submit" disabled={loading || !email || !password}>
          {loading ? 'Anmelden…' : 'Anmelden'}
        </button>
      </form>
    </div>
  );
}
